import Image from "next/image";
import Link from "next/link";

const DataNotFound = ({ title, image, button, subtitle }) => {
  return (
    <div className="rbt-error-area bg-gradient-11 rbt-section-gap w-100">
      <div className="error-area">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-10">
              {/* <h1 className="title">404!</h1> */}
              {/*  eslint-disable-next-line jsx-a11y/alt-text */}
              {image?.src && <Image {...image} />}
              <h3 className="sub-title">{title}</h3>
              <p>{subtitle}</p>
              {button && (
                <Link
                  className="rbt-btn btn-gradient icon-hover"
                  href={button.href}
                >
                  <span className="btn-text">{button.title}</span>
                  <span className="btn-icon">
                    <i
                      className={
                        button.icon ? button.icon : "feather-arrow-right"
                      }
                    ></i>
                  </span>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataNotFound;
